import classNames from 'classnames'
import type {Moment} from 'moment'

import {useBuildId} from '../../../hooks/routes'
import {useIsAutodetectTimeZone} from '../../../hooks/useIsAutodetectTimeZone'
import {getBuild} from '../../../selectors'
import {parseDateToObj} from '../../../utils/dateTimeUtils'

import styles from './BuildDurationEstimate.css'

import {useAppSelector} from 'src/hooks/react-redux'

function formatInterval(start: Moment, finish: Moment | null) {
  let result = start.format(`D MMM HH:mm`)

  if (finish != null) {
    result += ` – ${finish.format(`${finish.isSame(start, 'day') ? '' : 'D MMM '}HH:mm`)}`
  }

  return result
}

function BuildDurationEstimate() {
  const buildId = useBuildId()
  const startEstimate = useAppSelector(state => getBuild(state, buildId)?.startEstimate)
  const finishEstimate = useAppSelector(state => getBuild(state, buildId)?.finishEstimate)
  const isAutodetectTimeZone = useIsAutodetectTimeZone()
  const classes = classNames({
    [styles.unknown]: startEstimate == null,
  })
  return (
    <span
      title={
        startEstimate != null
          ? `Estimated start${finishEstimate != null ? ' / finish' : ''}`
          : undefined
      }
      className={classes}
    >
      {startEstimate != null
        ? formatInterval(
            parseDateToObj(startEstimate, isAutodetectTimeZone),
            finishEstimate != null ? parseDateToObj(finishEstimate, isAutodetectTimeZone) : null,
          )
        : 'Unknown time to start'}
    </span>
  )
}

export default BuildDurationEstimate
